document.querySelectorAll('[data-product-root]').forEach((root) => {
  const dataNode = root.querySelector('[data-product-json]');
  if (!dataNode) return;
  const data = JSON.parse(dataNode.textContent);
  const select = root.querySelector('[data-variant-select]');
  const optionInputs = [...root.querySelectorAll('[data-option-value]')];
  const zoomButton = root.querySelector('[data-product-zoom-open]');
  const zoomDialog = root.querySelector('[data-product-zoom-dialog]');
  const zoomImage = root.querySelector('[data-product-zoom-image]');
  const formatMoney = (cents) => window.Shopify?.formatMoney ? window.Shopify.formatMoney(cents) : new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
  let syncBundle = () => {};
  const showMedia = (mediaId) => {
    if (!mediaId) return;
    root.querySelectorAll('[data-media-id], [data-product-media-panel]').forEach((panel) => { panel.hidden = String(panel.dataset.mediaId || panel.dataset.productMediaPanel) !== String(mediaId); });
    root.querySelectorAll('[data-media-target]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.mediaTarget) === String(mediaId) ? 'true' : 'false'));
    const activePanel = root.querySelector(`.store-main-media > [data-media-id="${mediaId}"]:not([hidden]), .store-main-media > [data-product-media-panel="${mediaId}"]:not([hidden]) [data-media-id]`);
    if (zoomButton) zoomButton.hidden = !activePanel?.classList.contains('responsive-media--image');
  };
  const selectedOptionValues = () => {
    const values = [];
    optionInputs.forEach((input) => {
      if (input.checked) values[Number(input.dataset.optionPosition) - 1] = input.value;
    });
    return values;
  };
  const variantMatchesOptions = (variant, values) => values.every((value, index) => value == null || variant.options?.[index] === value);
  const updateOptionAvailability = () => {
    optionInputs.forEach((input) => {
      const position = Number(input.dataset.optionPosition) - 1;
      const hasAvailableVariant = data.variants.some((variant) => variant.available && variant.options?.[position] === input.value);
      input.disabled = !hasAvailableVariant;
      input.closest('.variant-option-value')?.classList.toggle('is-unavailable', !hasAvailableVariant);
    });
  };
  const syncOptionControls = (variant) => {
    optionInputs.forEach((input) => {
      const position = Number(input.dataset.optionPosition) - 1;
      input.checked = variant.options?.[position] === input.value;
    });
    root.querySelectorAll('[data-option-selected]').forEach((label) => {
      const position = Number(label.dataset.optionSelected) - 1;
      label.textContent = variant.options?.[position] || '';
    });
    updateOptionAvailability();
  };
  const closestAvailableVariant = (changedInput) => {
    const requested = selectedOptionValues();
    const exactAvailable = data.variants.find((variant) => variant.available && variantMatchesOptions(variant, requested));
    if (exactAvailable) return exactAvailable;

    const changedPosition = Number(changedInput.dataset.optionPosition) - 1;
    return data.variants
      .filter((variant) => variant.available && variant.options?.[changedPosition] === changedInput.value)
      .map((variant) => ({
        variant,
        score: requested.reduce((total, value, index) => total + (index !== changedPosition && variant.options?.[index] === value ? 1 : 0), 0),
      }))
      .sort((a, b) => b.score - a.score)[0]?.variant
      || data.variants.find((variant) => variantMatchesOptions(variant, requested));
  };
  const applyVariant = (variant, updateUrl = true) => {
    if (!variant) return;
    if (select) select.value = String(variant.id);
    syncOptionControls(variant);
    const price = root.querySelector('[data-product-price]');
    if (price) price.textContent = formatMoney(variant.price);
    const compare = root.querySelector('[data-compare-price]');
    if (compare) { compare.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : ''; compare.hidden = !(variant.compare_at_price > variant.price); }
    const sku = root.querySelector('[data-product-sku]');
    if (sku) sku.textContent = variant.sku || '';
    root.querySelectorAll('[data-product-detail-sku]').forEach((item) => { item.textContent = variant.sku || ''; });
    const availability = root.querySelector('[data-product-availability]');
    if (availability) availability.textContent = variant.available ? root.dataset.inStock || 'In stock' : root.dataset.soldOut || 'Sold out';
    const stock = root.querySelector('[data-variant-stock]');
    if (stock) stock.textContent = variant.available ? root.dataset.inStock || 'In stock' : root.dataset.soldOut || 'Sold out';
    const button = root.querySelector('[data-add-to-cart]');
    if (button) button.disabled = !variant.available;
    const buttonText = root.querySelector('[data-add-to-cart-text]');
    if (buttonText) buttonText.textContent = variant.available ? root.dataset.addToCart || 'Add to cart' : root.dataset.soldOut || 'Sold out';
    const bundleCurrent = root.querySelector('[data-bundle-current]');
    if (bundleCurrent) {
      bundleCurrent.dataset.variantId = String(variant.id);
      bundleCurrent.dataset.price = String(variant.price);
      bundleCurrent.querySelector('[data-bundle-item-price]').textContent = formatMoney(variant.price);
      const bundleImage = bundleCurrent.querySelector('img');
      const variantImage = variant.featured_image?.src || variant.featured_image;
      if (bundleImage && variantImage) bundleImage.src = variantImage;
      syncBundle();
    }
    if (variant.featured_media) showMedia(variant.featured_media.id);
    if (updateUrl && /^https?:$/.test(window.location.protocol)) {
      const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
    }
  };
  optionInputs.forEach((input) => input.addEventListener('change', () => {
    if (input.checked) applyVariant(closestAvailableVariant(input));
  }));
  select?.addEventListener('change', () => applyVariant(data.variants.find((variant) => String(variant.id) === select.value)));
  const initialVariant = data.variants.find((variant) => String(variant.id) === String(select?.value)) || data.variants.find((variant) => variant.available) || data.variants[0];
  if (initialVariant) applyVariant(initialVariant, false);
  root.querySelectorAll('[data-media-target]').forEach((button) => button.addEventListener('click', () => showMedia(button.dataset.mediaTarget)));

  const bundleOffer = root.querySelector('[data-bundle-offer]');
  if (bundleOffer) {
    const bundleCurrent = bundleOffer.querySelector('[data-bundle-current]');
    const bundleExtras = [...bundleOffer.querySelectorAll('[data-bundle-extra]')];
    const bundleButton = bundleOffer.querySelector('[data-bundle-add]');
    const bundleStatus = bundleOffer.querySelector('[data-bundle-status]');
    const originalPrice = bundleOffer.querySelector('[data-bundle-original]');
    const bundlePrice = bundleOffer.querySelector('[data-bundle-price]');
    const savingsText = bundleOffer.querySelector('[data-bundle-savings]');
    const countText = bundleOffer.querySelector('[data-bundle-count]');
    const discountRate = Math.max(0, Math.min(100, Number(bundleOffer.dataset.discountPercent) || 0)) / 100;
    const selectedItems = () => [bundleCurrent, ...bundleExtras.filter((item) => item.querySelector('[data-bundle-checkbox]')?.checked)].filter(Boolean);

    syncBundle = () => {
      const items = selectedItems();
      const subtotal = items.reduce((total, item) => total + (Number(item.dataset.price) || 0), 0);
      const hasExtra = items.length > 1;
      const savings = hasExtra ? Math.round(subtotal * discountRate) : 0;
      originalPrice.textContent = hasExtra ? formatMoney(subtotal) : '';
      bundlePrice.textContent = formatMoney(subtotal - savings);
      savingsText.textContent = hasExtra ? `You save ${formatMoney(savings)}` : 'Select an extra to unlock bundle savings';
      countText.textContent = String(items.length);
      bundleButton.disabled = !hasExtra;
    };

    bundleExtras.forEach((item) => item.querySelector('[data-bundle-checkbox]')?.addEventListener('change', syncBundle));
    bundleButton?.addEventListener('click', async () => {
      const items = selectedItems().map((item) => ({ id: Number(item.dataset.variantId), quantity: 1 })).filter((item) => Number.isFinite(item.id));
      if (items.length < 2) return;
      bundleButton.disabled = true;
      bundleButton.setAttribute('aria-busy', 'true');
      bundleStatus.hidden = false;
      bundleStatus.textContent = 'Adding your bundle to the bag...';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!response.ok) throw new Error('The bundle could not be added. Please check availability and try again.');
        const discountCode = bundleOffer.dataset.discountCode?.trim();
        window.location.assign(discountCode ? `/discount/${encodeURIComponent(discountCode)}?redirect=/cart` : '/cart');
      } catch (error) {
        bundleStatus.textContent = error instanceof Error ? error.message : 'The bundle could not be added. Please try again.';
        bundleButton.removeAttribute('aria-busy');
        syncBundle();
      }
    });
    syncBundle();
  }

  root.querySelectorAll('[data-product-tabs]').forEach((tabs) => {
    const buttons = [...tabs.querySelectorAll('[data-product-tab]')];
    const panels = [...tabs.querySelectorAll('[data-product-tab-panel]')];
    const activate = (name, focus = false) => {
      buttons.forEach((button) => {
        const active = button.dataset.productTab === name;
        button.setAttribute('aria-selected', String(active));
        button.tabIndex = active ? 0 : -1;
        if (active && focus) button.focus();
      });
      panels.forEach((panel) => { panel.hidden = panel.dataset.productTabPanel !== name; });
    };
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => activate(button.dataset.productTab));
      button.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
        activate(buttons[nextIndex].dataset.productTab, true);
      });
    });
    activate(buttons.find((button) => button.getAttribute('aria-selected') === 'true')?.dataset.productTab || buttons[0]?.dataset.productTab);
  });

  root.querySelectorAll('[data-quantity-controls]').forEach((controls) => {
    const input = controls.querySelector('input[name="quantity"]');
    const decrease = controls.querySelector('[data-quantity-decrease]');
    const increase = controls.querySelector('[data-quantity-increase]');
    const sync = () => {
      const value = Math.min(Number(input.max || 99), Math.max(Number(input.min || 1), Number(input.value) || 1));
      input.value = String(value);
      decrease.disabled = value <= Number(input.min || 1);
      increase.disabled = value >= Number(input.max || 99);
    };
    decrease?.addEventListener('click', () => { input.stepDown(); sync(); });
    increase?.addEventListener('click', () => { input.stepUp(); sync(); });
    input?.addEventListener('change', sync);
    sync();
  });

  const openProductZoom = () => {
    const activeImage = root.querySelector('.store-main-media > [data-media-id]:not([hidden]) img, .store-main-media > [data-product-media-panel]:not([hidden]) img');
    if (!activeImage || !zoomDialog || !zoomImage) return;
    zoomImage.src = activeImage.currentSrc || activeImage.src;
    zoomImage.alt = activeImage.alt || document.querySelector('.store-product-copy h1')?.textContent || '';
    zoomDialog.showModal();
  };
  zoomButton?.addEventListener('click', openProductZoom);
  root.querySelectorAll('[data-variant-zoom]').forEach((button) => button.addEventListener('click', () => {
    if (!zoomDialog || !zoomImage || !button.dataset.variantZoomSrc) return;
    zoomImage.src = button.dataset.variantZoomSrc;
    zoomImage.alt = button.dataset.variantZoomAlt || '';
    zoomDialog.showModal();
  }));
  root.querySelector('[data-product-zoom-trigger]')?.addEventListener('click', (event) => {
    if (event.target.closest('button, video, iframe, model-viewer') || !event.target.closest('img')) return;
    openProductZoom();
  });
  zoomDialog?.querySelector('[data-product-zoom-close]')?.addEventListener('click', () => zoomDialog.close());
  zoomDialog?.addEventListener('click', (event) => { if (event.target === zoomDialog) zoomDialog.close(); });

  const description = root.querySelector('[data-product-description]');
  const normalizedDescriptionText = (element) => element?.textContent.replace(/\u00a0/g, ' ').trim() || '';
  if (description) {
    [...description.children].forEach((element) => {
      const hasMedia = Boolean(element.querySelector('img, video, iframe, model-viewer'));
      const hasText = Boolean(normalizedDescriptionText(element));
      if (!hasText && hasMedia) element.classList.add('product-description-image-block');
      if (!hasText && !hasMedia) element.classList.add('product-description-empty-block');
    });
  }
  if (description && !normalizedDescriptionText(description)) description.closest('.product-detail-story')?.classList.add('is-image-only');
  const imageGroups = description ? [...description.children].filter((element) => element.querySelector(':scope > img')) : [];
  const descriptionImages = imageGroups.flatMap((group) => [...group.querySelectorAll(':scope > img')]);
  if (description && !normalizedDescriptionText(description) && imageGroups.length > 1 && descriptionImages.length >= 3) {
    const leadCount = imageGroups[0].querySelectorAll(':scope > img').length;
    const remainingCount = descriptionImages.length - leadCount;
    const secondCount = Math.ceil(remainingCount / 2);
    const chapterImages = [
      descriptionImages.slice(0, leadCount),
      descriptionImages.slice(leadCount, leadCount + secondCount),
      descriptionImages.slice(leadCount + secondCount),
    ];
    const chapterNames = ['performance', 'details', 'care'];
    const fragment = document.createDocumentFragment();
    chapterImages.forEach((images, index) => {
      const chapter = document.createElement('article');
      chapter.className = `product-detail-story__chapter product-detail-story__chapter--${chapterNames[index]}`;
      const media = document.createElement('figure');
      media.className = index === 0 ? 'product-detail-story__media product-description-image-lead' : 'product-detail-story__media product-description-image-grid';
      images.forEach((image) => media.append(image));
      chapter.append(media);
      fragment.append(chapter);
    });
    description.replaceChildren(fragment);
    description.classList.add('is-chapterized');
  } else {
    const leadImages = description?.querySelector(':scope > div:has(> img:nth-child(2)):not(:has(> img:nth-child(3)))');
    if (leadImages) leadImages.classList.add('product-description-image-lead');
    const imageGrid = description?.querySelector(':scope > div:has(> img:nth-child(5))');
    if (imageGrid) imageGrid.classList.add('product-description-image-grid');
  }
});
